import { createApi } from '@reduxjs/toolkit/query/react';

import { ApiResponse } from '../../../model';
import { API_CONSTANTS } from '../../../utils/constants';

import type { EditProfile, ProfileUpdateRequest } from './model';
import { baseQueryWithReauth } from '../../../apis/baseQuery';

export const editProfileApi = createApi({
  reducerPath: 'editProfileApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['Profile'],
  endpoints: (build) => ({
    adminProfile: build.query<ApiResponse<EditProfile>, void>({
      query: () => ({
        url: API_CONSTANTS.ADMIN.ADMIN_PROFILE_URL,
        method: 'GET',
      }),
      providesTags: ['Profile'],
    }),
    identity: build.query<ApiResponse<any>, void>({
      query: () => ({
        url: API_CONSTANTS.IDENTITY_ENDPOINT,
        method: 'GET',
      }),
      providesTags: ['Profile'],
    }),
    adminProfileUpdate: build.mutation<
      ApiResponse<Record<string, never>>,
      ProfileUpdateRequest
    >({
      query: (body) => ({
        url: API_CONSTANTS.EDIT_PROFILE_URL,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Profile'],
    }),
  }),
});

export const {
  useAdminProfileQuery,
  useLazyAdminProfileQuery,
  useAdminProfileUpdateMutation,
  useIdentityQuery,
  useLazyIdentityQuery,
} = editProfileApi;

export default editProfileApi;
